import React from 'react';
import { ContainerMeuPlano } from './styles';
import { CardMeuPlano } from './components/CardMeuPlano';
import { CurrentPlan } from './components/CurrentPlan';
// import { ChangePaymentMethod } from './components/ChangePaymentMethod';
import { AvailablePlans } from './components/AvailablePlans';
// import { Invoices } from './components/Invoices';
// import { ChangeBillingDetails } from './components/ChangeBillingDetails';
import { useMeuPlano } from './hooks/useMeuPlano';
// import { CancelSubscription } from './components/CancelSubscription';

export const MeuPlanoContent: React.FC = () => {
  const { screen, isPlanoExpirado, isPlanoExpiradoDemonstracao } =
    useMeuPlano();

  const expiredPlanTitle = isPlanoExpiradoDemonstracao
    ? 'Período de teste encerrado'
    : 'Plano expirado';

  const expiredPlanMessage = isPlanoExpiradoDemonstracao
    ? 'Seu período de teste terminou, contrate um plano para continuar usando o sistema através dos números:'
    : 'Seu plano expirou. Para renovar, entre em contato através dos números:';

  if (isPlanoExpirado) {
    return (
      <ContainerMeuPlano>
        <div className="meu-plano-expirado">
          <div className="meu-plano-expirado-card">
            <h2>{expiredPlanTitle}</h2>

            <p>
              {expiredPlanMessage} <br /> <strong>(18) 99800-2145</strong> e{' '}
              <strong>(11) 3181-5480</strong>
            </p>
          </div>
        </div>
      </ContainerMeuPlano>
    );
  }

  return (
    <ContainerMeuPlano>
      {screen === 'HOME' && (
        <section
          className="meu-plano-dashboard"
          aria-label="Resumo do meu plano"
        >
          <div className="meu-plano-slot meu-plano-slot--current">
            <CardMeuPlano
              screenOpen="GERENCIAR-ASSINATURA"
              content={<CurrentPlan />}
              disableClick
            />
          </div>

          {/* <div className="meu-plano-slot meu-plano-slot--plans">
            <CardMeuPlano
              screenOpen="PLANOS-DISPONIVEIS"
              content={<AvailablePlans />}
            />
          </div> */}

          {/* <CardMeuPlano
            screenOpen="MUDAR-FORMA-PAGAMENTO"
            content={<ChangePaymentMethod />}
          /> */}

          {/* <CardMeuPlano screenOpen="FATURAS" content={<Invoices />} /> */}

          {/* <CardMeuPlano
            screenOpen="MUDAR-DADOS-COBRANCA"
            content={<ChangeBillingDetails />}
          /> */}
        </section>
      )}

      {screen === 'GERENCIAR-ASSINATURA' && (
        <div className="meu-plano-single-view">
          <CurrentPlan />
        </div>
      )}

      {/* {screen === 'MUDAR-FORMA-PAGAMENTO' && <ChangePaymentMethod />} */}

      {(screen === 'PLANOS-DISPONIVEIS' ||
        screen === 'PLANOS-DISPONIVEIS-DADOS') && (
        <div className="meu-plano-single-view">
          <AvailablePlans />
        </div>
      )}

      {/* {screen === 'FATURAS' && <Invoices />} */}
      {/* {screen === 'MUDAR-DADOS-COBRANCA' && <ChangeBillingDetails />} */}
      {/* {screen === 'CANCELAR-ASSINATURA' && <CancelSubscription />} */}
    </ContainerMeuPlano>
  );
};
